export default __webpack_public_path__ + "static/media/input.c1a3fc37.svg";